export const TABS = {
  label: {
    engaged: "Comprometido",
    billable: "Facturable",
    list: "Listado",
  },
};
